import type { StyledProps } from '@compiled/react';
import { styled } from '@compiled/react';
import type { ComponentType, ClassAttributes, HTMLAttributes } from 'react';

export type SelectionRect = {
	top: number;
	left: number;
	width: number;
	height: number;
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const CurrentSelectionSpan: ComponentType<
	{
		top: number;
		left: number;
		width: number;
		height: number;
	} & ClassAttributes<HTMLSpanElement> &
		HTMLAttributes<HTMLSpanElement> &
		StyledProps
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
> = styled.span<{
	top: number;
	left: number;
	width: number;
	height: number;
}>({
	opacity: 0,
	position: 'absolute',
	pointerEvents: 'none',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	top: `${(props: { top: number }) => props.top}px`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	left: `${(props: { left: number }) => props.left}px`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	width: `${(props: { width: number }) => props.width}px`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	height: `${(props: { height: number }) => props.height}px`,
});
